import PaymentsInfoPanel from './PaymentsInfoPanel';

export default PaymentsInfoPanel;
